import { combineReducers } from "redux";
import idsOfFetchingFilters, {
  IdsOfFetchingFilters,
} from "./idsOfFetchingFilters";
import idsOfSubmittingFilters, {
  IdsOfSubmittingFilters,
} from "./idsOfSubmittingFilters";
import idsOfTemplatesFetchingFilters, {
  IdsOfTemplatesFetchingFilters,
} from "./idsOfTemplatesFetchingFilters";
import allFiltersFetching, { AllFiltersFetching } from "./allFiltersFetching";
import filters, { Filters } from "./filters";

type State = {
  filters: Filters;
  idsOfFetchingFilters: IdsOfFetchingFilters;
  idsOfSubmittingFilters: IdsOfSubmittingFilters;
  idsOfTemplatesFetchingFilters: IdsOfTemplatesFetchingFilters;
  allFiltersFetching: AllFiltersFetching;
};

export default combineReducers<State>({
  filters,
  idsOfFetchingFilters,
  idsOfSubmittingFilters,
  idsOfTemplatesFetchingFilters,
  allFiltersFetching,
});

export type UserFilterSlice = State;
